export default {"src":"/login-app/[GIT_HASH]/_next/static/media/lineage_downstream.957173f5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};